import React, { useState } from "react";
import styled from "styled-components";
import { MaterialCubicBezier, MobileWidth } from "../../GlobalStyle";

function Accordion({ content }) {
  const [active, setActive] = useState(false);

  return (
    <AccordionBox
      className={`accordion-item ${active ? "active" : ""}`}
      onClick={() => setActive(!active)}
    >
      <div className="accordion-title">{content.question}</div>
      <div className="accordion-content">{content.answer}</div>
    </AccordionBox>
  );
}

export default Accordion;

const AccordionBox = styled.div`
  cursor: pointer;
  
  &:not(:last-child) {
    border-bottom: 1px solid rgba(255, 255, 255, 0.4);
  }

  &.active {
    .accordion-title:before {
      transform: rotate(180deg);
    }
    .accordion-content {
      max-height: 500px;
      opacity: 1;
      transform: scaleY(1);
    }
  }

  .accordion-title {
    font-size: 1.6rem;
    padding: 20px 20px 20px 0;
    position: relative;
    text-transform: uppercase;
    @media screen and (max-width: ${MobileWidth}) {
      font-size: 1.3rem;
    }

    &:before {
      background: url(${require("../../images/icon-chevron.png")}) center /
        contain no-repeat;
      content: "";
      height: 12px;
      width: 12px;
      position: absolute;
      right: 5px;
      top: 50%;
      transform: translateY(-50%);
      transition: all 200ms ${MaterialCubicBezier};
    }
  }

  .accordion-content {
    max-height: 0;
    opacity: 0;
    transform: scaleY(0);
    transform-origin: top;
    transition: all 200ms ${MaterialCubicBezier};

    p {
      color: #ffffffc7;
      line-height: 1.5rem;
      margin-bottom: 20px;
      margin-top: 5px;
    }
    strong {
      font-size: 1.2rem;
      @media screen and (max-width: ${MobileWidth}) {
        font-size: 1.1rem;
      }
    }
    ul {
      color: #ffffffc7;
      line-height: 1.5rem;
      margin: 0;
      padding-left: 22px;
    }
  }
`;
